<template>
    <div class="end-body">
        <div class="rank-content">
            <div v-if="lists.length>0" class="con-item" v-for="(item,index) in lists" :key="index">
                <div class="con-img" @click="go.goDetail(item.id)">
                    <img :src="item.img">
                </div>
                <div class="con-info">
                    <div class="info-title" @click="go.goDetail(item.id)">{{item.title}}</div>
                    <tags :tags="item.tags"></tags>
                    <p class="info-des" v-html="item.abst"  @click="go.goDetail(item.id)"></p>
                </div>
            </div>
            <div v-if="lists.length==0&&keyword!=''" class="nodata">
                 <div class="no-data">
                    <nodata :msg="nomsg" :padding="nopadd"></nodata>
                </div>
            </div>
            <infinite-loading v-if="(type == 'end' || type == 'rank') && page > 0" @infinite="getDatas">
					      <span slot="no-more" style="color:#ccc">
					         {{$t("nomoredata")}}
					      </span>
					  </infinite-loading>
        </div>
        <!--底部组件-->
        <pagebottom></pagebottom>
    </div>
</template>

<script>
import pagebottom from "@/components/common/pagebottom";
import tags from "@/components/common/tags";
import nodata from "@/components/common/nodata";
import InfiniteLoading from 'vue-infinite-loading';
export default {
  name: "end",
  components: {
    pagebottom,
    nodata,
    tags,
    InfiniteLoading
  },
  props: ["type","typeid","cate_id","keyword"],
  data() {
    return {
      //没有数据展示信息 msg 默认‘暂无小说上架~’ padding上下间距 默认200
      nopadd: 200,
      nomsg: "暂无数据",
      pageInfo: {},
      lists: [],
      page: 0
    };
  },
  watch: {
    keyword: {
      handler(newValue, oldValue) {
        this.getList();
      }
    },
    cate_id:{
      handler(newValue,oldValue){
        if(newValue>0){
          this.getList();
        }
      }
    }
  },
  mounted: function() {
    this.getList();
    this.nomsg = this.$t("noresult");
  },
  methods: {
    getList: function() {
      if (this.type == "end") {
        this.$indicator.open({
          text: "Loading...",
          spinnerType: "fading-circle"
        });
        this.req.end(this.page).then(res => {
          this.$indicator.close();
          this.lists = res.data.list;
          this.pageInfo = res.data.pageInfo;
          this.page = 1;
        });
      } else if (this.type == "rank") {
        this.$indicator.open({
          text: "Loading...",
          spinnerType: "fading-circle"
        });
        this.req.hots(this.page).then(res => {
          this.$indicator.close();
          this.lists = res.data.list;
          this.pageInfo = res.data.pageInfo;
          this.page = 1;
        });
      } else if (this.type == "more") {
        this.$indicator.open({
          text: "Loading...",
          spinnerType: "fading-circle"
        });
        this.req.indexMoreList(this.typeid).then(res => {
          this.$indicator.close();
          this.lists = res.data.list;
          this.pageInfo = res.data.pageInfo;
        });
      } else if (this.type == "search") {
        if (this.keyword != ""||this.cate_id>0) {
          this.$indicator.open({
            text: "Loading...",
            spinnerType: "fading-circle"
          });
          this.req.search(this.page, this.keyword,this.cate_id).then(res => {
            this.$indicator.close();
            this.lists = res.data.list;
            this.pageInfo = res.data.pageInfo;
          });
        }
      }
    },
    getDatas: function ($state) {
    	if (this.type == "end") {
    		this.page += 1;
        this.req.end(this.page).then(res => {
        	const dataObj = res.data.list;
        	if (dataObj.length) {
        		res.data.list.map(item => {
              this.lists.push(item);
           	});
          	this.pageInfo = res.data.pageInfo;
          	$state.loaded();
          	if (this.page == this.pageInfo.totalPage) {
		　　　　　　　　$state.complete();
		　　　　　　}
        	} else {
        		$state.complete();
        	}
        });
      } else if (this.type == "rank") {
    		this.page += 1;
        this.req.hots(this.page).then(res => {
        	const dataObj = res.data.list;
        	if (dataObj.length) {
        		res.data.list.map(item => {
              this.lists.push(item);
           	});
          	this.pageInfo = res.data.pageInfo;
          	$state.loaded();
          	if (this.page == this.pageInfo.totalPage) {
		　　　　　　　　$state.complete();
		　　　　　　}
        	} else {
        		$state.complete();
        	}
        });
      }
    }
  }
};
</script>

<style scoped>
.nodata {
  min-height: 10em;
}
.end-body {
  width: 100%;
  left: 0;
  top: 0;
  background: #f2f2f2;
}
.rank-content {
  width: 100%;
  height: auto;
  margin-top: 0.16rem;
  padding-bottom: 0.28rem;
  background: #ffffff;
}
.con-item {
  width: 100%;
  height: 3.38rem;
  box-sizing: border-box;
  border-bottom: 0.02rem solid #f2f2f2;
  padding: 0.4rem;
  display: flex;
  justify-content: space-between;
  background: #ffffff;
}
.con-img {
  width: 1.82rem;
  height: 2.56rem;
  overflow: hidden;
}
.con-img img {
  display: block;
  height: 2.56rem;
}
.con-info {
  width: 4.48rem;
  height: auto;
}
.info-title {
  font-size: 0.28rem;
  line-height: 0.28rem;
  padding-bottom: 0.38rem;
  font-weight: 700;
}
.info-tags {
  width: 100%;
}
.tag-item {
  font-size: 0.2rem;
  color: #666666;
  border: 0.01rem solid #666666;
  border-radius: 0.08rem;
  float: right;
  padding: 0.06rem 0.1rem;
  margin-left: 0.1rem;
}
.info-des {
  width: 100%;
  box-sizing: border-box;
  padding: 0.24rem 0 0 0;
  font-size: 0.22rem;
  line-height: 0.4rem;
  color: #666666;
  display: -webkit-box;
  -webkit-line-clamp: 3;
  -webkit-box-orient: vertical;
  overflow: hidden;
    height: 1.42rem;
}
</style>


// WEBPACK FOOTER //
// src/components/index/list.vue